import { render, staticRenderFns } from "./ReferTrigger.vue?vue&type=template&id=595e6274&scoped=true&"
import script from "./ReferTrigger.vue?vue&type=script&lang=js&"
export * from "./ReferTrigger.vue?vue&type=script&lang=js&"
import style0 from "./ReferTrigger.vue?vue&type=style&index=0&id=595e6274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595e6274",
  null
  
)

export default component.exports